<template>
<span id="add-barCodeUser-dialog" v-if="showAddUsers()">
    <el-button id="btn-add-user" type="success" plain @click="dialogVisible = true" size="mini">{{ $t('barCodeUserType.addUser') }}</el-button>
    <el-dialog
    :close-on-click-modal="false"
    v-on:open="handleOpen"
    :title="$t('barCodeUserType.addUser')"
    :visible.sync="dialogVisible"
    width="65%"
    class="dialog-with-cols"
    :before-close="handleClose">
    <el-form :model="form" :rules="formRules" ref="form" label-position="top" size="mini">
        <el-row>
        <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
              <el-form-item :label="$t('barCodeUserType.userId')" prop="userId">
                  <el-input
                  v-model="form.userId"
                  clearable
                  v-alphanumeric-validation
                  maxlength="5"
                  class="inline-input"
                  id="form-userId"
                  ></el-input>
              </el-form-item>
          </el-col>
          <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
              <el-form-item :label="$t('barCodeUserType.pin')" prop="pin">
                  <el-input
                  v-model="form.pin"
                  v-numeric-validation
                  clearable
                  maxlength="5"
                  class="inline-input"
                  id="form-pin"
                  ></el-input>
              </el-form-item>
          </el-col>
          <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
              <el-form-item :label="$t('barCodeUserType.fullName')" prop="fullName">
                  <el-input
                  v-model="form.fullName"
                  clearable
                  v-alphanumeric-validation
                  maxlength="100"
                  class="inline-input"
                  id="form-fullName"
                  ></el-input>
              </el-form-item>
          </el-col>
          <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
              <el-form-item :label="$t('barCodeUserType.role')" prop="role">
                <el-select
                v-model="form.role"
                id="form-role"
                >
                <el-option
                  v-for="item in roleOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
                </el-select>
              </el-form-item>
          </el-col>
          <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
              <el-form-item :label="$t('barCodeUserType.warehouseCode')" prop="warehouseId">
                  <el-select v-model="form.warehouseId" id="form-warehouse-id">
                    <el-option
                    v-for="item in warehouseOptions"
                    :key="item.id"
                    :label="item.code"
                    :value="item.id">
                    </el-option>
                </el-select>
              </el-form-item>
          </el-col>
          <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
              <el-form-item :label="$t('barCodeUserType.company')" prop="company">
                  <el-input
                      v-model="form.company"
                      clearable
                      v-alphanumeric-validation
                      maxlength="100"
                      class="inline-input"
                      id="form-company"
                  ></el-input>
              </el-form-item>
          </el-col>
      </el-row>
    </el-form>
        <div id="add-dialog-footer" slot="footer" class="dialog-footer form-vertical-item flex-reverse-direction">
            <el-button type="primary" id="form-save-button" @click="submitForm()" size="mini">{{ $t('barCodeUserType.addUser') }}</el-button>
            <el-button id="form-refresh-button" @click="resetForm()" size="mini">{{ $t('barCodeUserType.clear') }}</el-button>
        </div>
    </el-dialog>
</span>
</template>

<script>
import { Message } from 'element-ui';
import { mapGetters } from 'vuex';
import constants from '@/utils/constants';

export default {
  computed: {
    ...mapGetters([
      'barcodeUser'
    ])
  },
  data() {
    const validPin = (rule, value, callback) => {
      if (this.form.pin <= 0) {
        callback(new Error(this.$t('barCodeUserType.error.pinNotZero')));
      } else {
        callback();
      }
    };
    return {
      yes: constants.STATUS_BOOLEAN.yes,
      no: constants.STATUS_BOOLEAN.no,
      roleOption: constants.BAR_CODE_USER.ROLE_OPTIONS_ADD,
      dialogVisible: false,
      warehouseOptions: [],
      form: {
        userId: '',
        pin: '',
        fullName: '',
        role: '',
        warehouseId: '',
        company: ''
      },
      formRules: {
        userId: [
          { required: true, message: this.$t('barCodeUserType.error.userIdRequired'), trigger: 'blur' },
        ],
        pin: [
          { required: true, message: this.$t('barCodeUserType.error.pinRequired'), trigger: 'blur' },
          { validator: validPin, trigger: 'blur' }
        ],
        fullName: [
          { required: true, message: this.$t('barCodeUserType.error.fullNameRequired'), trigger: 'blur' }
        ],
        role: [
          { required: true, message: this.$t('barCodeUserType.error.roleRequired'), trigger: 'blur' }
        ],
        warehouseId: [
          { required: true, message: this.$t('barCodeUserType.error.warehouseIdRequired'), trigger: 'blur' }
        ],
      }
    };
  },
  methods: {
    handleOpen() {
      this.$nextTick(() => {
        this.resetForm();
      });
    },
    handleClose(done) {
      done();
    },
    submitForm() {
      return new Promise((resolve) => {
        this.$refs.form.validate((valid) => {
          if (valid) {
            Message.closeAll();
            const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
            this.$store
              .dispatch('barcodeUser/save', this.form)
              .then((response) => {
                loading.close();
                this.$message.success(response.message);
                this.resetForm();
                this.$store.dispatch('barcodeUser/search', {});
                resolve(response);
              })
              .catch((error) => {
                loading.close();
                resolve(error);
              });
          } else {
            resolve(new Error(this.$t('common.invalid')));
          }
        });
      });
    },
    resetForm() {
      this.$refs.form.resetFields();
      this.form.userId = '';
      this.form.pin = '';
      this.form.fullName = '';
      this.form.role = '';
      this.form.warehouseId = '';
    },
    showAddUsers() {
      return this.$can(this.permissions.WAREHOUSE.EDIT_BARCODE_USER);
    }
  },
  mounted() {
    this.$store.dispatch('warehouse/getWarehouseCodes').then(({ data }) => {
      this.warehouseOptions = data;
    });
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
    #add-barCodeUser-dialog  {
        .el-select, .el-date-editor {
            width: 100% !important;
        }
    }
</style>
